const APP = require('APP')

const router = require('router')
const user = require('Models/UserModel')
const win = require('Helpers/win')

const GamesCollection = require('Collections/Games')
const GamesLastPlayView = require('Views/GamesLastPlayView')
const GamePlayContainerView = require('Views/GamePlay/GamePlayContainerView')
const Tournaments = require('./Tournaments').default
const { UserNotifications } = require('./UserNotifications')
const { initTranslations } = require('../../app/utils/initTranslations')

user.onLoadConfig(async (data) => {
  await initTranslations()

  const gamesData = data.games

  GamesCollection.init(gamesData, data)

  init()
})

function init() {
  const loader = document.getElementById('loader')
  if (loader) {
    loader.style.opacity = 0
    setTimeout(() => {
      loader.remove()
    }, 500)
  }

  router.addMap({
    game_play(route) {
      if (route.params.slug && route.params.forFun !== undefined) {
        const gm = GamesCollection.get(route.params.slug)
        let gcv = new GamePlayContainerView({ gameModel: gm, forFun: route.params.forFun })
        let lastGameModel = gcv.model || gcv.gameModel
        const tournaments = new Tournaments()
        tournaments.initialize()

        if (user.config.isLogged && APP.isUserNotificationFeatureEnabled) {
          new UserNotifications()
        }

        if (!MOBILE || APP.IS_ELECTRON) {
          GamesLastPlayView.init()
        }

        APP.hideGame = () => {
          if (gcv) {
            gcv.hideGame()
          }
        }

        APP.showGame = () => {
          if (gcv) {
            gcv.showGame()
          }
        }

        APP.gameScreenshot = (callback) => {
          if (gcv.iframe && gcv.iframe.contentWindow) {
            let ti
            const postmsgCallback = (event) => {
              window.removeEventListener('message', postmsgCallback)

              if (event && event.data && event.data.screenshot) {
                clearTimeout(ti)
                // eslint-disable-next-line no-console
                console.timeEnd('postMessage GetScreenshot')
                callback(event.data.screenshot)
              } else {
                callback(false)
              }
            }

            window.addEventListener('message', postmsgCallback, false)
            // eslint-disable-next-line no-console
            console.time('postMessage GetScreenshot')
            gcv.iframe.contentWindow.postMessage('getScreenshot', '*')

            ti = setTimeout(() => {
              callback(false)
              window.removeEventListener('message', postmsgCallback)
            }, 1000) // 10sec;
          } else if (gcv.gamePlayView && gcv.gamePlayView.getScreenshot) {
            return gcv.gamePlayView.getScreenshot(callback)
          }

          return null
        }

        APP.getGameNumber = () => {
          if (gcv.gamePlayView && gcv.gamePlayView.model) {
            return gcv.gamePlayView.model.gameModel.get('number')
          }

          return null
        }

        const gcvOnClose = () => {
          lastGameModel = gcv.model || gcv.gameModel
          gcv.off('remove', gcvOnClose)
          gcv = undefined
          const history = router.getHistory()
          if (history.length === 1) {
            /** is fist page user opens (or refresh on it) */
            GamesLastPlayView.addGame(lastGameModel)
            router.pathRedirect('home')
          } else {
            let gamePlayPage = true
            let i = history.length

            /** while router on histroy array
             * is not a 'game play' router */
            while (history[i - 1] && gamePlayPage) {
              i--
              gamePlayPage = history[i].name === 'game_play'
            }

            if (gamePlayPage) {
              /** if there is no non game play router in history */
              router.pathRedirect('home')
            } else {
              const addLastGameFn = () => {
                user.off('sync', addLastGameFn)
                // eslint-disable-next-line no-console
                console.log('add last played game')
                GamesLastPlayView.addGame(lastGameModel)
              }
              user.on('sync', addLastGameFn)

              router.prevPage(true, i - history.length + 1)
            }
          }
        }

        const closeGame = () => {
          router.off('change', closeGame)
          if (gcv) {
            // eslint-disable-next-line no-console
            console.log('add last played game', lastGameModel)
            GamesLastPlayView.addGame(lastGameModel)

            gcv.off('destroy', gcvOnClose)
            gcv.destroy()
            gcv = undefined

            setTimeout(() => {
              if (win.$wrapper.length === 0) {
                router.refresh()
              }
            }, 200)
          }
        }

        gcv.on('destroy', gcvOnClose)

        router.off('change', closeGame).on('change', closeGame)
      }
    },
  })
}
